import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { growthAreas } from '../../data/offer';
export function Overview() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-label="A more structured way" data-id="element-299" data-mp="1nmp8kc8i9qye">
      <div className="mx-auto max-w-5xl" data-id="element-300" data-mp="1ilrvuf69lp4a">
        <SectionHeading title={<>
              A more structured way to understand <span className="text-electric" data-id="element-302" data-mp="1wk7ynv10avh5">maxillary growth</span>
            </>} subtitle="What if you could bring the essential concepts of craniofacial growth assessment together in one organized clinical reference?" data-id="element-301" data-mp="1ip5x1k36zsa5" />

        <div className="mx-auto mt-8 max-w-3xl space-y-4 text-base leading-relaxed text-ink/80 sm:text-lg" data-id="element-303" data-mp="21ec60fe6p5ir">
          <p data-id="element-304" data-mp="2gbczoofxrajv">
            Maxillary growth assessment involves more than identifying whether a jaw appears narrow, protrusive, or
            retrusive.
          </p>
          <p data-id="element-305" data-mp="39tu7j8gvflit">
            It requires understanding skeletal relationships, developmental stages, facial patterns, clinical records,
            and the factors that influence orthopedic treatment considerations.
          </p>
          <p className="font-semibold text-navy-950" data-id="element-306" data-mp="3isxuinj5sl2l">
            That’s why MAXILLARY GROWTH BLUEPRINT™ brings these interconnected topics into one structured educational
            system — built for dental professionals who want greater clarity when studying growing patients.
          </p>
        </div>

        <div className="mt-12 rounded-3xl bg-mist p-6 sm:p-10" data-id="element-307" data-mp="1kkgxco6pd2t">
          <h3 className="text-center font-display text-xl font-black uppercase leading-tight text-navy-950 sm:text-2xl" data-id="element-308" data-mp="6c2ahfnvobdr">
            Designed around 6 essential areas of clinical understanding
          </h3>
          <ul className="mt-7 grid gap-3 md:grid-cols-2" data-id="element-309" data-mp="fe1saa6pvjhr">
            {growthAreas.map(area => <li key={area} className="flex items-start gap-3 rounded-2xl bg-white px-4 py-4 text-[15px] font-semibold leading-snug text-ink sm:text-base" data-id="element-310" data-mp="kbk54bnuuiv1">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-electric text-white" data-id="element-311" data-mp="2gd599gqw5nts">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-312" data-mp="2q51dzanhgc6z" />
                </span>
                {area}
              </li>)}
          </ul>
        </div>

        <div className="mt-10" data-id="element-313" data-mp="2z5ppnypem0gp">
          <CtaButton label="Get the complete 6-volume system" data-id="element-314" data-mp="2z4y65m92zt6s" />
        </div>
      </div>
    </section>;
}